module.exports = __webpack_public_path__ + "img/giropay.7cf9b8cd.svg";